import { LocalizedElement, sourceAttribute } from "../../i18n/LocalizedCopy";
import { LocalizedText, useSourceLanguage } from "../../i18n/LocalizedCopy";
import React from "react";

export default function WelcomeOfferActions({
  phase,
  offer,
  onClaim,
  onReconcile,
  onDiscover,
  onDismiss,
}) {
  useSourceLanguage();
  const claiming = phase === "claiming";
  const uncertain = phase === "uncertain";
  const unavailable = phase === "unavailable";
  const primaryLabel =
    phase === "offline" || phase === "recoverable"
      ? "Réessayer"
      : "Activer mon bonus";

  return (
    <div className="welcome-offer-actions">
      {!unavailable ? (
        <button
          type="button"
          className="welcome-offer-actions__primary"
          onClick={uncertain ? onReconcile : onClaim}
          disabled={claiming}
          aria-busy={claiming ? "true" : undefined}
        >
          <span>{claiming ? <LocalizedText source={"Activation sécurisée…"} /> : uncertain ? <LocalizedText source={"Vérifier l’état"} /> : <LocalizedText source={primaryLabel} />}</span>
          {claiming ? (
            <i className="welcome-offer-actions__spinner" aria-hidden="true" />
          ) : (
            <span aria-hidden="true">→</span>
          )}
        </button>
      ) : null}

      <button
        type="button"
        className="welcome-offer-actions__secondary"
        onClick={onDiscover}
      ><LocalizedText source={"Découvrir Eternua"} /></button>

      <button
        type="button"
        className="welcome-offer-actions__later"
        onClick={onDismiss}
      ><LocalizedText source={"Plus tard"} /></button>

      <p className="welcome-offer-actions__terms">
        {offer?.termsUrl ? (
          <LocalizedElement elementType={"a"} copyAttributes={["aria-label"]}
            href={offer.termsUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={sourceAttribute("Offre soumise aux conditions (nouvel onglet)")}
          ><LocalizedText source={"Offre soumise aux conditions"} /><span className="welcome-offer-sr-only"><LocalizedText source={" (nouvel onglet)"} /></span>
          </LocalizedElement>
        ) : (
          <span><LocalizedText source={"Offre soumise aux conditions"} /></span>
        )}
        <span aria-hidden="true"> • </span><LocalizedText source={"Affichée uniquement si elle est active"} /></p>
    </div>
  );
}
